import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilterIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 15,
	height: 15,
	viewBox: "0 0 12 12",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip-path",
		children: /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_13401",
			"data-name": "Rectangle 13401",
			width: 15,
			height: 15,
			transform: "translate(0 -0.442)",
			fill: "#efeffa",
			stroke: "#618cf5",
			strokeWidth: 1
		})
	}) }), /* @__PURE__ */ _jsx("g", {
		id: "Group_8169",
		"data-name": "Group 8169",
		transform: "translate(0 0.531)",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Group_7639",
			"data-name": "Group 7639",
			transform: "translate(0 -0.089)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_12985",
				"data-name": "Path 12985",
				d: "M11.539.5H.5L5.3,6.3v5.236l1.44-1.44V6.3Z",
				transform: "translate(-0.26 -0.146)",
				fill: "#efeffa",
				stroke: "#618cf5",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			})
		})
	})]
});
export default SvgFilterIcon;
